import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Tone } from "../Tone";
import { isUndef } from "./TypeCheck";
/**
 * Emitter gives classes which extend it
 * the ability to listen for and emit events.
 * Inspiration and reference from Jerome Etienne's [MicroEvent](https://github.com/jeromeetienne/microevent.js).
 * MIT (c) 2011 Jerome Etienne.
 * @category Core
 */

export var Emitter = /*#__PURE__*/function (_Tone) {
  _inherits(Emitter, _Tone);

  var _super = _createSuper(Emitter);

  function Emitter() {
    var _this;

    _classCallCheck(this, Emitter);

    _this = _super.apply(this, arguments);
    _this.name = "Emitter";
    return _this;
  }
  /**
   * Bind a callback to a specific event.
   * @param  event     The name of the event to listen for.
   * @param  callback  The callback to invoke when the event is emitted
   */


  _createClass(Emitter, [{
    key: "on",
    value: function on(event, callback) {
      var _this2 = this;

      // split the event
      var events = event.split(/\W+/);
      events.forEach(function (eventName) {
        if (isUndef(_this2._events)) {
          _this2._events = {};
        }

        if (!_this2._events.hasOwnProperty(eventName)) {
          _this2._events[eventName] = [];
        }

        _this2._events[eventName].push(callback);
      });
      return this;
    }
    /**
     * Bind a callback which is only invoked once
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */

  }, {
    key: "once",
    value: function once(event, callback) {
      var _this3 = this;

      var boundCallback = function boundCallback() {
        // invoke the callback
        callback.apply(void 0, arguments); // remove the event

        _this3.off(event, boundCallback);
      };

      this.on(event, boundCallback);
      return this;
    }
    /**
     * Remove the event listener.
     * @param  event     The event to stop listening to.
     * @param  callback  The callback which was bound to the event with Emitter.on.
     *                   If no callback is given, all callbacks events are removed.
     */

  }, {
    key: "off",
    value: function off(event, callback) {
      var _this4 = this;

      var events = event.split(/\W+/);
      events.forEach(function (eventName) {
        if (isUndef(_this4._events)) {
          _this4._events = {};
        }

        if (_this4._events.hasOwnProperty(event)) {
          if (isUndef(callback)) {
            _this4._events[event] = [];
          } else {
            var eventList = _this4._events[event];

            for (var i = eventList.length - 1; i >= 0; i--) {
              if (eventList[i] === callback) {
                eventList.splice(i, 1);
              }
            }
          }
        }
      });
      return this;
    }
    /**
     * Invoke all of the callbacks bound to the event
     * with any arguments passed in.
     * @param  event  The name of the event.
     * @param args The arguments to pass to the functions listening.
     */

  }, {
    key: "emit",
    value: function emit(event) {
      if (this._events) {
        if (this._events.hasOwnProperty(event)) {
          var eventList = this._events[event].slice(0);

          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          for (var i = 0, len = eventList.length; i < len; i++) {
            eventList[i].apply(this, args);
          }
        }
      }

      return this;
    }
    /**
     * Add Emitter functions (on/off/emit) to the object
     */

  }, {
    key: "dispose",
    value:
    /**
     * Clean up
     */
    function dispose() {
      _get(_getPrototypeOf(Emitter.prototype), "dispose", this).call(this);

      this._events = undefined;
      return this;
    }
  }], [{
    key: "mixin",
    value: function mixin(constr) {
      // instance._events = {};
      ["on", "once", "off", "emit"].forEach(function (name) {
        var property = Object.getOwnPropertyDescriptor(Emitter.prototype, name);
        Object.defineProperty(constr.prototype, name, property);
      });
    }
  }]);

  return Emitter;
}(Tone);